let mapContainers;
const stylesNormal = [
    {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [
            {
                saturation: 36,
            },
            {
                color: '#000000',
            },
            {
                lightness: 40,
            },
        ],
    },
    {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                visibility: 'on',
            },
            {
                color: '#000000',
            },
            {
                lightness: 16,
            },
        ],
    },
    {
        featureType: 'all',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 13,
            },
        ],
    },
    {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 13,
            },
            {
                weight: 1.2,
            },
        ],
    },
    {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 13,
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 13,
            },
        ],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 30,
            },
        ],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 30,
            },
            {
                weight: 0.4,
            },
        ],
    },
    {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 18,
            },
        ],
    },
    {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 18,
            },
        ],
    },
    {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 18,
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
            {
                color: '#000000',
            },
            {
                lightness: 0,
            },
        ],
    },
];

function renderGoogleMap() {
    mapContainers = document.querySelectorAll('dl.google-map-pp__map');


    [].forEach.call(mapContainers, (el) => {
        init(el);
    });
}

function init(mapContainer) {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
            const userPosition = { lat: position.coords.latitude, lng: position.coords.longitude};
            renderMap(mapContainer, userPosition);
        }, ()=>(renderMap(mapContainer)));
    } else {
        renderMap(mapContainer);
    }
}


function renderMap(mapContainer, userPosition = {}) {
    const locations = mapContainer.querySelectorAll('.google-map-pp__poi');
    const cta = mapContainer.getAttribute('data-call_t_action');
    const image = {
        url: mapContainer.getAttribute('data-map_ico'),
        scaledSize: new google.maps.Size(35, 48),
    };

    const map = new google.maps.Map(mapContainer, {
        styles: stylesNormal,
    });


    const infoWindow = new google.maps.InfoWindow();
    const bounds = new google.maps.LatLngBounds();
    const userLocation = (Object.keys(userPosition).length>0) ? new google.maps.LatLng(userPosition) : {};

    const nearest = [...locations].reduce((prev, curr) => {
        const poiTitle = curr.innerHTML;
        const poiLat = curr.getAttribute('data-map_poi_lat');
        const poiLng = curr.getAttribute('data-map_poi_lng');

        const markerPosition = new google.maps.LatLng(poiLat, poiLng);


        const marker = new google.maps.Marker({
            position: markerPosition,
            map,
            icon: image,
        });

        bounds.extend(markerPosition);


        google.maps.event.addListener(marker, 'click', (function(element) {
            return () => {
                infoWindow.setContent(`<div class="google-map-pp__info">${poiTitle}
<a href="https://maps.google.com?saddr=Current+Location&daddr=${poiLat},${poiLng}" class="btn bg-info">${cta}</a>
</div>`);
                infoWindow.open(map, element);
            };
        }(marker)));


        if (Object.values(userLocation).length > 0) {
            const cpos = google.maps.geometry.spherical.computeDistanceBetween(userLocation, markerPosition);
            const ppos = (Object.keys(prev).length > 0) ?
                google.maps.geometry.spherical.computeDistanceBetween(userLocation, prev) :
                NaN;

            return (!ppos || cpos <= ppos) ? markerPosition : prev;
        }
        return null;
    }, {});


    if (nearest) {
        map.setCenter(nearest);
        map.setZoom(10);
    } else if (locations.length === 1) {
        const el = locations[0];
        const poiLat = el.getAttribute('data-map_poi_lat');
        const poiLng = el.getAttribute('data-map_poi_lng');
        const markerPosition = new google.maps.LatLng(poiLat, poiLng);
        map.setCenter(markerPosition);
        map.setZoom(14);
    } else {
        map.fitBounds(bounds);
    }
}

export default renderGoogleMap;
